import { CurrentUserService } from "@gtmhub/users";
import { BadgeService } from "@gtmhub/badges";
import { GtmhubController } from "@gtmhub/core";
import { CurrentEmployeeActions, ICurrentEmployeeStoreState, IEmployee } from "@gtmhub/employees";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { INgRedux } from "@gtmhub/state-management";
import { IComponentOptions, IController, IPromise } from "angular";

const bindStateToScope = (state: ICurrentEmployeeStoreState): IHomeFeedNavBarCtrlRedux => {
  const { info: currentEmployee, isFetched: currentEmployeeFetched, error: currentEmployeeError } = state.currentEmployee;

  return {
    reduxStatesInitialized: currentEmployeeFetched,
    reduxStateError: currentEmployeeError,
    employee: currentEmployee,
  };
};

interface IHomeFeedNavBarCtrlRedux {
  employee: IEmployee;
  reduxStatesInitialized: boolean;
  reduxStateError: IUIError;
}

export interface IHomeFeedNavBarCtrlScope extends IExtendedRootScopeService, IHomeFeedNavBarCtrlRedux {
  employee: IEmployee;
  loading: boolean;
  reduxStatesInitialized: boolean;
  hideActionButtons: boolean;
}

export class HomeFeedNavBarCtrl extends GtmhubController implements IController {
  public static $inject = ["$scope", "$ngRedux", "UIErrorHandlingService", "CurrentEmployeeActions", "BadgeService", "CurrentUserService"];

  constructor(
    private $scope: IHomeFeedNavBarCtrlScope,
    private $ngRedux: INgRedux,
    private uiErrorHandlingService: UIErrorHandlingService,
    private currentEmployeeActions: CurrentEmployeeActions,
    private badgeService: BadgeService,
    private currentUserService: CurrentUserService
  ) {
    super();
    this.$scope.loading = true;

    this.$scope.$on("homeScreenChanged", () => (this.$scope.hideActionButtons = this.shouldHideActionButtons()));

    const unsubscribe = this.$ngRedux.connect(bindStateToScope)(this.$scope);
    this.$scope.$on("$destroy", unsubscribe);
  }

  $onInit(): IPromise<unknown> {
    this.$ngRedux.dispatch(this.currentEmployeeActions.fetchCurrentEmployeeIfMissing());
    this.$scope.hideActionButtons = this.shouldHideActionButtons();

    return this.$scope
      .watchUntilAndRejectOnError(
        () => this.$scope.reduxStatesInitialized,
        () => this.$scope.reduxStateError
      )
      .then(
        () => this.getBadges(),
        () => this.handleError(this.$scope.reduxStateError)
      )
      .then(() => (this.$scope.loading = false))
      .catch((error) => {
        this.$scope.loading = true;
        this.handleError(error);
      });
  }

  private getBadges = (): IPromise<unknown> => {
    return this.badgeService.getCurrentUserBadges().then((badges) => {
      this.$scope.employee.badges = badges.items;
    });
  };

  private handleError = <E>(error: E): void => {
    this.uiErrorHandlingService.handleModal(error);
  };

  private shouldHideActionButtons = (): boolean => {
    return this.currentUserService.getUserSetting("homeScreen") === "feed";
  };
}

export const HomeFeedNavBarComponent: IComponentOptions = {
  controller: HomeFeedNavBarCtrl,
  templateUrl: require("./home-feed-nav-bar.component.jade"),
};
